import { useEffect, useState } from "react";

import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import useLocalStorage from "@app/common/hooks/useLocalStorage";

import Checkbox from "@rui/Checkbox";
import ConfirmationModal from "@rui/ConfirmationModal";

import useEditStore from "../stores/edits";

const DELETE_CONFIRMATION_MODAL_LOCAL_STORAGE_KEY =
  "deleteTranscriptTurnConfirmationModalDismissed";

const DeleteTurnConfirmationModal = () => {
  const [checked, setChecked] = useState(false);
  const [deleteTurnModalDismissed, setDeleteTurnModalDismissed] =
    useLocalStorage(DELETE_CONFIRMATION_MODAL_LOCAL_STORAGE_KEY, false);

  const { modal, setModal, turnToDelete, deleteTurn, reopenTurn } =
    useEditStore((state) => ({
      modal: state.modal,
      setModal: state.setModal,
      turnToDelete: state.transcript.turnToDelete,
      deleteTurn: state.deleteTurn,
      reopenTurn: state.startEditingItem,
    }));

  useEffect(() => {
    if (deleteTurnModalDismissed && turnToDelete) {
      deleteTurn(turnToDelete);
    }
  }, [turnToDelete]);

  if (deleteTurnModalDismissed || !turnToDelete) {
    return null;
  }

  const closeModal = () => {
    setChecked(false);
    setModal(null);
  };

  const handleDeleteTurn = () => {
    // only persist to local storage on confirmation
    setDeleteTurnModalDismissed(checked);
    deleteTurn(turnToDelete);
    closeModal();
  };

  const handleCancel = () => {
    closeModal();
    reopenTurn({ type: "turn", item: turnToDelete });
  };

  return (
    <ConfirmationModal
      open={modal === "confirm_delete_turn"}
      onClose={handleCancel}
      onConfirm={handleDeleteTurn}
      title="Delete turn?"
      size="md"
      confirmProps={{
        label: "Yes, delete",
        type: "negative",
      }}
      showHeaderCloseButton
    >
      <Stack spacing={1}>
        <Typography variant="bodyPrimaryReg" color="shades.neutral.600">
          When you delete a turn, others will be able to see that you deleted
          content in the transcript. Do you want to continue?
        </Typography>
        <FormControlLabel
          control={<Checkbox checked={checked} />}
          onChange={(_, checked) => setChecked(checked)}
          label={
            <Typography variant="bodySecondaryReg" color="shades.neutral.600">
              Don't show this again
            </Typography>
          }
          sx={{ marginLeft: "-6px" }}
        />
      </Stack>
    </ConfirmationModal>
  );
};

export default DeleteTurnConfirmationModal;
